import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_CHECK,
  AUTH_ERROR,
  AUTH_GET_PERMISSIONS,
} from 'react-admin'
import { get } from 'lodash'

import { authService, isAuthenticated, setAuthenticated } from './authService'
import {
  AuthParamsProtocol,
  AuthServiceResponseProtocol,
} from './authProtocols'

export default async (type: string, params: AuthParamsProtocol) => {
  if (type === AUTH_LOGIN) {
    const response: AuthServiceResponseProtocol = await authService(params)
    const user_id = get(response, 'user.user_id', '')
    const token = get(response, 'user.token', '')
    const cms = get(response, 'user.cms', true)
    const userRole = get(response, 'user.ms1_access_level', '')
    const status = get(response, 'status', 500)

    if (!token || status !== 200 || !cms)
      return Promise.reject({ redirectTo: '/login' })

    setAuthenticated(token)

    localStorage.setItem('user_id', user_id)
    localStorage.setItem('permissions', userRole)
    return Promise.resolve()
  }
  if (type === AUTH_LOGOUT) {
    localStorage.clear()
    return Promise.resolve()
  }
  if (type === AUTH_ERROR) {
    return Promise.resolve()
  }
  if (type === AUTH_GET_PERMISSIONS) {
    const role = localStorage.getItem('permissions')
    return role ? Promise.resolve(role) : Promise.reject()
  }
  if (type === AUTH_CHECK) {
    try {
      const auth = await isAuthenticated()
      if (auth) return Promise.resolve()
    } catch (e) {
      // Dispatch error log
    }

    localStorage.clear()
    return Promise.reject({ redirectTo: '/login' })
  }

  return Promise.reject('Unknown method')
}
